import React from 'react'

import Section from '../../../shared/settings/section'
import OptIns from './opt-ins'
import { TESTERS } from '../../../../lib/tester-classnames'

function CommunicationSettings() {
  return (
    <Section title="Communication Settings" testerClassName={TESTERS.ACCOUNT.COMMUNICATION_SETTINGS}>
      <OptIns />
    </Section>
  )
}

export default CommunicationSettings
